import { Navigate, useRoutes } from 'react-router-dom';

// pages
import Home from './pages/Home';
import GuidedSearch from './pages/GuidedSearch';
import FAQ from './pages/FAQ';
import i18n from './locales/i18n';
import LanguageSelector from './pages/LanguageSelector';
import OverviewPage from './pages/OverviewPage';
import Provinces from './pages/Provinces';
import PageNotFound from './pages/PageNotFound';

// ----------------------------------------------------------------------


export default function Router() {
  const language = () => i18n.language
  return useRoutes([
    {
        path: `/`, element: <Navigate to={`/${language()}/nrcan-map`}/>
    },
    // {
    //   path: 'languageselection', element: <LanguageSelector />
    // },
    {
      path: `/${language()}/nrcan-map`, element: <Home />
    },
    {
        path: `/${language()}/search`, element: <GuidedSearch />
    },
    {
      path: `/${language()}/faq`, element: <FAQ />
    },
    {
      path: `/${language()}/overview/:id`, element: <OverviewPage />
    },
    {
      path: `/${language()}/regional-resources`, element: <Provinces/>
    },
    { 
      path: '*', element: <PageNotFound /> 
    }
  ]);
}

